module.exports = __webpack_public_path__ + "vue/img/aicon (20).b14594a2.png";